<template>
  <div>
    <b-modal
      id="modalUploadMaterial"
      centered
      size="lg"
      title="Subir archivo"
      hide-footer
      @show="close">
        <div>
          <form-render
            :form.sync="form"
            :fields="fields"
            class="mt-0"
            @send="onAccept"
            containerButtonsClass="col-sm-12"
            ref="formUploadMaterials">
          </form-render>
        </div>
        <div class="col-md-12" v-if="rows.length > 0">
          <b-alert variant="warning" show class="p-1">
            <div class="d-flex justify-content-center align-items-center">
              <feather-icon size="30" class="mr-50" icon="InfoIcon"/>
              <span>
                {{ processMessage }}
              </span>
            </div>
          </b-alert>
          <table-render
            :rows="rows"
            :schema="schema"
            class="col-md-12 my-1">
          </table-render>
        </div>
        <div class="col-12">
          <b-button @click="ok" class="push-right" variant="outline-success" :disabled="loading.uploadFile">
            {{$t('Actualizar solicitudes')}}
            <feather-icon v-if="!loading.uploadFile" icon="UploadIcon"/>
            <i v-else :class="['fa', 'fa-spinner', 'fa-spin']"/>
          </b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import MaterialsService from './materials.service'
export default {
  data() {
    return {
      fields: [],
      form: {},
      loading: {
        uploadFile: false
      },
      rows: [],
      schema: [
        { label: 'ID', key: 'id' },
        { label: 'Error', key: 'reason' }
      ],
      processMessage: '',
      materialsService: new MaterialsService(this)
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData() {
      this.fields = [
        {
          fieldType: 'FieldFileDropArea',
          name:'file_materials',
          label: 'Archivo de importación',
          labelFormFile: 'Subir archivo',
          validation: 'required',
          containerClass: 'col-12 container-info',
          accept: '.xls, .xlsx',
          classField:'hide-button-browse',
          clearable: true
        }
      ]
    },
    close () {
      this.form = {}
      this.rows = []
      this.processMessage = ''
      this.loading.uploadFile = false
    },
    ok(e) {
      e.preventDefault()
      this.$refs.formUploadMaterials.checkForm()
    },
    onAccept(data) {
      this.loading.uploadFile = true
      const formData = new FormData()
      formData.append('file', data.file_materials)
      this.materialsService.callService('uploadMaterials', formData)
        .then(resp => {
          if (resp.data.errors.length > 0) {
            this.rows = resp.data.errors
            this.processMessage = resp.data.message
          } else {
            this.$bvModal.hide('modalUploadMaterial')
            this.$success(this.$t('Archivo subido correctamente'))
            this.$emit('send')
          }
        })
        .catch(err => {
          this.$alert(this.$t('Ha ocurrido un error al subir el archivo, intente nuevamente.'))
        })
        .finally(() => {
          this.loading.uploadFile = false
        })
    }
  }
}
</script>

<style>

</style>